export default "__VITE_ASSET__BRFWLFEi__"